import { defineComponent as _defineComponent } from 'vue'
type TagOptions = 'default' | 'jacaranda' | 'sherbert' | 'sage';

interface Props {
  icon?: string;
  borderVariant?: TagOptions;
  iconVariant?: TagOptions;
  bgVariant?: TagOptions;
  title: string;
  ariaLabel?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 't-tag',
  props: {
    icon: null,
    borderVariant: null,
    iconVariant: null,
    bgVariant: null,
    title: null,
    ariaLabel: null
  },
  setup(__props: any) {



function borderClass(variant: TagOptions): string[] {
  switch (variant) {
    case 'default':
      return ['tw-border-grey-400'];
    case 'jacaranda':
      return ['tw-border-jacaranda-dark'];
    case 'sherbert':
      return ['tw-border-sherbert'];
    case 'sage':
      return ['tw-border-sage'];
    default:
      throw new Error('unreachable');
  }
}
function bgClass(variant: TagOptions): string[] {
  switch (variant) {
    case 'default':
      return ['tw-bg-white'];
    case 'jacaranda':
      return ['tw-bg-jacaranda-dark'];
    case 'sherbert':
      return ['tw-bg-sherbert'];
    case 'sage':
      return ['tw-bg-sage'];
    default:
      throw new Error('unreachable');
  }
}
function iconClass(variant: TagOptions): string[] {
  switch (variant) {
    case 'default':
      return ['tw-text-tsblack'];
    case 'jacaranda':
      return ['tw-text-jacaranda-dark'];
    case 'sherbert':
      return ['tw-text-sherbert'];
    case 'sage':
      return ['tw-text-sage'];
    default:
      throw new Error('unreachable');
  }
}

return { __sfc: true,borderClass, bgClass, iconClass }
}

})